export const domainTag = 'frontend_portal_';

export const frontEndFlags = [
  'addChannel',
  'addStoresButton',
  'alertBannerInvoice',
  'appStore',
  'appstoreDeveloper',
  'avoidDataDog',
  'filterOrdersByDateRange',
  'hideAppStoreInstallationPopUp',
  'internationalisedAddress',
  'lazyLoadMenuItems',
  'loyaltyCampaignVoucherSwitch',
  'mobileApps',
  'nestedModifiers',
  'noStoreOverridesBeforeCurrentTime',
  'nutritionalInformation',
  'orderFulfillmentStatusConfigurations',
  'orderFulfillmentStatusOrderDetails',
  'paygreenFeatures',
  'preventStorePublishWithoutAddress',
  'showNewProfilePassword',
  'showNextGenEditor',
  'showPayoutsStoreOptions',
  'showPosInPayoutReport',
  'smartlookImplementation',
  'storeOrderBatching',
  'tablePrefix',
  'tippingCustom',
  'tippingReduceValues',
  'tippingRoundUp',
  'useInjectedRecaptchaKey',
] as const;

export type FrontEndFlag = typeof frontEndFlags[number];
